import portalCommunication from '@3plearning/mathletics-portal-communication-service';
import Resources from './resources';

class ErrorHandling {
    static addResourceResponseErrorInterceptor(dispatch) {
        // The interceptor needs access to dispatch() so that it can
        // initiate the opening of a model dialog, so we bind it in
        // as the first parameter.

        const interceptor = ErrorHandling.handleErrors.bind(this, dispatch);

        Resources.env.addResponseInterceptor(interceptor);
    }

    static handleErrors(dispatch, result) {
        let valid = false;

        try {
            switch (result.status) {
            case 200:
            case 201:
            case 204:
            case 400: // bad request handle locally
                valid = true;
                break;
            case 401:
            case 403:
            case 404:
            case 500:
                break;
            default:
            }
        } catch (e) {
            //
        }
        // Global Error handling
        if (valid === false) {
            portalCommunication.requestServerError();
            dispatch(ErrorHandling.badTokenWarning());
        }

        // Pass Errors to Local actions to handle explicitly
        // when result.valid === true BUT
        // result contains result.message && result.code,
        // it means it requires to handle in async functions response
        result.valid = valid;

        return result;
    }

    static badTokenWarning() {
        return {
            type: '',
            payload: {}
        };
    }
}

export default ErrorHandling;



// WEBPACK FOOTER //
// ./helpers/error-handling.js